export type FrontendErrorOptions = {
  code: string;
  cause?: unknown;
};

export class FrontendError {
  readonly id: string;
  readonly code: string;
  readonly cause?: unknown;
  readonly capturedAt: number;

  constructor(opts: FrontendErrorOptions) {
    this.id = crypto.randomUUID();
    this.code = opts.code;

    if (opts.cause !== undefined) this.cause = opts.cause;
    this.capturedAt = Date.now();
  }
}
